import { render, staticRenderFns } from "./nuoChe.vue?vue&type=template&id=1cedbcfa"
import script from "./nuoChe.vue?vue&type=script&lang=js"
export * from "./nuoChe.vue?vue&type=script&lang=js"
import style0 from "./nuoChe.vue?vue&type=style&index=0&id=1cedbcfa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports